import React, { useState, useEffect } from 'react'
import { Panel, Form, Button, Message } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import { updateWithdrawRequest } from '../../redux/actions/withdrawRequest'
import pathname from '../../constants/pathname'
import { sendFeedback } from '../../redux/actions/projectProgress'

export default function SendFeedbackWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEditAll } = props
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressId, setProgressId] = useState('')

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    // let _progressId = location.search.substring(1)
    let _progressId = sessionStorage.getItem('param')?.substring(1)
    console.log('WithdrawRequestWidget', 'progress_id: ', _progressId)
    if (_progressId) {
      setProgressId(_progressId)
    }
  }, [location.search])

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call update.')
      const response = await sendFeedback(projectId, progressId, request)

      console.log('response', response)

      if (response) {
        setIsLoading(false)
        doneLoading()
        setIsError(false)
        setIsShowConfirm(false)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage)
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }
    setIsLoading(false)
    doneLoading()
    setIsShowConfirm(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = {
      //id: 'string',
      projectVersionId: projectId,
      //userId: 'string',
      projectProgressId: progressId,
      note: data.note,
    }
    console.log('request', request)
    setRequest(request)

    setIsShowConfirm(true)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)

    handleCallService(request)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {formSchema.note && (
        <InputForm
          schema={formSchema.note}
          rows={3}
          componentClass="textarea"
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      )}

      {isError && <Message showIcon type="error" description={isError} />}

      <hr />

      <Button ripple appearance="ghost" onClick={handleSubmit(onSubmit)}>
        {formSchema.buttonText}
      </Button>

      <ConfirmWidget
        title={`ยืนยันการ${formSchema.buttonText}`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${formSchema.buttonText}`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}

const note = {
  name: 'note',
  label: 'ความคิดเห็น',
  value: null,
  hint: 'ระบุความคิดเห็น',
  validators: [
    {
      type: 'REQUIRED',
      value: null,
      errorMessage: 'โปรดระบุ ความคิดเห็น',
    },
  ],
}
